/*eslint-disable */
import React, { useEffect, useState } from 'react'
import { Button, Dropdown, Modal, Radio } from 'semantic-ui-react'
import { withFormik, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi, Checkbox } from "semantic-ui-react";
import { connect } from "react-redux";
import CreatAxios from '../../../components/axiosComponent/create';
import { successAlertDispatcher, errorAlertDispatcher } from '../../../redux/actions/alertAction';
import MyVehicleMaster from '../../../components/apiInputs/vehicleNumberDropdown';
import { translate } from 'react-i18next';
import cogoToast from "cogo-toast";

const AddDriverVehicle = ({ isSubmitting, handleSubmit, values, touched, errors, t, setFieldValue,openModal, CloseModal,  ...props }) => {
    return (
        <Modal
            onClose={CloseModal}
            open={openModal}
            size="small"
            className="p-overflow-initial"
        >
            <Modal.Header>{t('vehicles.add.title')}</Modal.Header>
            <Modal.Content>
                <div className="ui form small">
                    <FormUi.Group inline={errors.vehicleId || errors.vehicleId ? false : true}>
                        <FormUi.Field width="4">
                            <label className="labelName">{t("vehicles.add.vehicle_no")}</label><span className="text-danger">*</span>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="vehicleId" component={MyVehicleMaster} idValue={true} />
                            {touched.vehicleId && errors.vehicleId ? <small className="text-danger">{errors.vehicleId}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color='green' size="mini" type='button' onClick={CloseModal}>
                    {t("vehicles.add.cancel")}
                </Button>
                <Button type='submit' disabled={isSubmitting} onClick={handleSubmit} size="mini" color="blue">
                    {t("vehicles.add.ok")}
                </Button>
            </Modal.Actions>
        </Modal>
    )
}
const FormikAddDriverVehicle = withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        return {
            vehicleId:""
        }
    },
    validationSchema: yup.object({
        vehicleId: yup.string().required("Required")
    }),
    async handleSubmit(values, { props }) {
        if(props.driverId && values.vehicleId){
            let payload = {
                driverId : props.driverId,
                vehicleId : values.vehicleId
            }
            await CreatAxios({
                url: `vehicleDriver`,
                payload,
            })
                .then((res) => {
                    if (res?.data?.status === 200) {
                        cogoToast.success(res?.data?.message || "Success", {position: "top-right"});
                        window.location.reload()
                    } else {
                        cogoToast.error(res?.data?.message || "Failed to map vehicle to the driver", {position: "top-right"});
                    }
                })
                .catch((err) => {
                    if (err?.data?.status === 204) {
                        cogoToast.error(err?.data?.message || "Failed to map vehicle to the driver", {position: "top-right"});
                    }

                });
        }
    }

})(AddDriverVehicle)
export default connect(null, {
    successAlertDispatcher,
    errorAlertDispatcher
})(translate('driver')(FormikAddDriverVehicle))
